import { ComponentStyleConfig, theme as baseTheme } from '@chakra-ui/theme'

import { primaryColor } from '../foundations/primaryColor'

import { Text } from './text'

const { input: { bgPlaceholderColor } } = primaryColor

// You can also use the more specific type for
// a single part component: ComponentSingleStyleConfig

// when using ComponentStyleConfig you need specify when component your select
// example =  field | addon |  element

export const FormLabel: ComponentStyleConfig = {
  baseStyle: {
    ...baseTheme.components.FormLabel.baseStyle,
    color: bgPlaceholderColor,
    ...Text.variants?.SM
  },
}
